import { Button } from 'antd';
import { useAppSelector } from 'app/store';
import { getMultiSelectedSubtitutionVacations } from 'entities/vacationsSchedule/model/multiSelectSubtitution';
import React, { FC } from 'react';
import style from './index.module.scss';

type TChekboxPickProps = {
  pickAllData?: () => void;
  clearAllData: () => void;
  approve: () => Promise<void>;
  multivacations: number[];
};

const ChekboxPick: FC<TChekboxPickProps> = ({ pickAllData, clearAllData, approve, multivacations }) => {
  const approveRequests = () => {
    approve().finally(() => clearAllData());
  };

  return (
    <div className={style.buttons}>
      {pickAllData && <Button onClick={pickAllData}>Выбрать все</Button>}
      <Button disabled={multivacations.length === 0} onClick={clearAllData}>
        Очистить выборку
      </Button>
      <Button disabled={multivacations.length === 0} onClick={approveRequests} type="primary">
        Согласовать
      </Button>
    </div>
  );
};

export default ChekboxPick;
